import { useTranslation } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from '../../../i18n'
import { PLUS_BADGE_I18N_NAMESPACE } from '../i18n'
import { useExperiment } from './useExperiment'

type Badges = {
  duoBadge?: string
  familyBadge?: string
}

// Which plan carries a badge, per arm:
//
//   control    Duo none           Family "Best Value"   (today's page)
//   variant_1  Duo "Most Popular" Family "Best Value"   (two badges)
//   variant_2  Duo "Most Popular" Family none           (one badge)
//
// Any other bucket, and the flag being off, fall back to control — so an
// unbucketed visitor sees exactly the page we ship today.
export const useBadges = (): Badges => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const { t: tExperiment } = useTranslation(PLUS_BADGE_I18N_NAMESPACE)
  const { bucket } = useExperiment()

  const bestValue = t('plans.headers.bestValue')
  const badge = tExperiment('plans.headers.badge')

  switch (bucket) {
    case 'variant_1':
      return { duoBadge: badge, familyBadge: bestValue }
    case 'variant_2':
      return { duoBadge: badge, familyBadge: undefined }
    default:
      return { duoBadge: undefined, familyBadge: bestValue }
  }
}
